import React, { useEffect } from 'react';
import { ErrorMessage, Field, Form, Formik } from "formik";
import { addProduct } from "../../utils/validations"
import { useState } from 'react';
import gallery from "../../api/gallery";
import Swal from 'sweetalert2'
import productApi from "../../api/product";
import toast from 'react-hot-toast';
import routes from '../../utils/routes';
import { useNavigate } from 'react-router-dom';
import { Breadcrumb, Offcanvas } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import Actions from '../../store/actions';
import MultiPriceForm from './multiPriceForm';
import MultiListing from '../AddProduct/multiListing';
import { addIdToData } from '../../utils';
import GalleryList from '../gallery/GalleryList';
import RLDD from 'react-list-drag-and-drop/lib/RLDD';



let initialValuesForMultiPriceForm = {
   title: "",
   description: "",
   sellPrice: 0,
   oldPrice: 0,
   cost: 0,
   stockInHand: 1,
   barCode: "",
   colors: [],
}

let AddProductForm = ({ inputs }) => {
   let navigate = useNavigate()
   let dispatch = useDispatch();
   let brands = useSelector(data => data.brands);
   let products = useSelector(data => data.products);
   let categories = useSelector(data => data.categories);
   let settings = useSelector(data => data.profile.data.setting);
   let profile = useSelector(data => data.profile.data);
   const [color, setColor] = useState("");
   const [editSeo, setEditSeo] = useState(false);
   const [showGallery, setShowGallery] = useState(false);
   const [subcategories, setSubcategories] = useState([]);
   const [showMultiPriceForm, setShowMultiPriceForm] = useState(false);
   const [youtubeLink, setYoutubeLink] = useState("");
   const [filePercentageLoader, setFilePercentageLoader] = useState(100);
   const [multiInputs, setMultiInputs] = useState(initialValuesForMultiPriceForm)

   useEffect(() => {
      let categoryId = inputs?.category;
      if (categoryId) {
         let selectedIndex = categories?.data?.findIndex(data => data?._id == categoryId);
         setSubcategories(categories?.data[selectedIndex]?.subcategories);
      }
   }, [])


   let updateList = async (data, remove = false) => {
      console.log({ data })
      let list = products.data;
      if (remove) {
         list = list.filter(item => item._id != data._id);
      } else {
         if (inputs?._id) {
            let index = await list.findIndex(item => item?._id == data._id);
            if (index > -1) {
               list[index] = data
            }
         } else {
            list = [data, ...list]
         }
      }
      console.log({ list })
      list = await updateListOrder(list);
      dispatch(Actions.addProductsList({ data: list, pageLoaded: products?.pageLoaded }));
   }

   let updateListOrder = async (data) => {
      let list = await data?.map((data, index) => { return { ...data, id: index } })
      return list
   }

   return (
      <>
         <Formik
            initialValues={inputs}
            validationSchema={addProduct}
            onSubmit={async (values, { setSubmitting }) => {
               setSubmitting(true);
               let data = { ...values }
               if (data.brand == "") {
                  delete data.brand
               }
               if (data.category == "") {
                  delete data.category
               }
               if (data.subcategory == "") {
                  delete data.subcategory
               }
               console.log({ values, data });
               try {
                  let res = ""
                  if (data._id) {
                     res = await productApi.updateProduct(data)
                  } else {
                     res = await productApi.addProduct(data)
                  }
                  if (res.status == 200 || res.status == 201) {
                     toast.success(res.data.msg);
                     updateList(res.data.data);
                     navigate(routes.productList);
                  }
                  setSubmitting(false);
               } catch (error) {
                  console.log(error.message);
                  setSubmitting(false);
               }
            }}
         >
            {({ isSubmitting, values, errors, setFieldValue }) => (
               <Form>
                  <div className="container mt-4">
                     <div className="row">
                        <div className="col-12">
                           <Breadcrumb>
                              <Breadcrumb.Item href="#">
                                 Dashboard
                              </Breadcrumb.Item>
                              <Breadcrumb.Item active>{inputs?._id ? "Edit" : "Add New"} Product</Breadcrumb.Item>
                           </Breadcrumb>
                        </div>
                     </div>
                     <div className="row">
                        <div className="col-md-8">
                           <div className="bg-white rounded-0 p-2 p-md-3 mb-3">
                              <div className="d-flex justify-content-between">
                                 <div>
                                    <h4>Details</h4>
                                 </div>
                                 <div>
                                    {inputs.slug && (
                                       <p className='text-center'>
                                          <a
                                             href={"https://" + profile?.domain + `/product/${inputs.slug}`}
                                             target="_blank" rel="noopener noreferrer">View page</a>
                                       </p>
                                    )}
                                 </div>
                              </div>
                              <div className="form-group">
                                 <label htmlFor="">Product Title</label>
                                 <input type="text" className='form-control'
                                    value={values.title}
                                    onChange={(event) => {
                                       if (!editSeo) {
                                          setFieldValue("metaTitle", event.target.value);
                                       }
                                       setFieldValue("title", event.target.value);
                                    }}
                                 />
                                 <ErrorMessage name='title' component="small" className="text-danger" />
                              </div>
                              <div className="form-group">
                                 <label htmlFor="">Product Description</label>
                                 <textarea
                                    onChange={(event) => {
                                       if (!editSeo) {
                                          setFieldValue("metaDesc", event.target.value)
                                       }
                                       setFieldValue("description", event.target.value)
                                    }}
                                    value={values.description}
                                    className='form-control' ></textarea>
                                 <ErrorMessage name='description' component="small" className="text-danger" />
                              </div>
                              <div className="form-group">
                                 <label htmlFor="">Product features</label>
                                 <textarea className='form-control'
                                    onChange={(event) => setFieldValue("features", event.target.value)}
                                    value={values.features}
                                 ></textarea>
                              </div>
                              <div className="form-group">
                                 <label htmlFor="">Product instructions</label>
                                 <textarea className='form-control'
                                    onChange={(event) => setFieldValue("instructions", event.target.value)}
                                    value={values.instructions}
                                 ></textarea>
                              </div>
                              <div className="form-group">
                                 <label htmlFor="">Disclaimer</label>
                                 <textarea className='form-control'
                                    onChange={(event) => setFieldValue("disclaimer", event.target.value)}
                                    value={values.disclaimer}
                                 ></textarea>
                              </div>
                           </div>
                           <div className="bg-white rounded-0 p-2 p-md-3 mb-3">
                              <h4>Pictures</h4>

                              <div className="uploadPictureWrapper">
                                 <RLDD
                                    items={values?.images?.map((data, index) => ({ ...data, id: index }))}
                                    itemRenderer={(data, imageIndex) => {
                                       return (
                                          <div key={imageIndex}>
                                             <div className='pictureWrapper'>
                                                <img src={data.url} alt="" className='pointer'
                                                   onClick={() => {
                                                      setFieldValue("image", data.url);
                                                   }}
                                                />
                                                {values.image == data.url && (
                                                   <span className='selectedImage'>
                                                      <i className='fas fa-check'></i>
                                                   </span>
                                                )}
                                                <span className='remove'
                                                   onClick={() => {
                                                      console.log({ data })
                                                      let images = values?.images?.filter((data, itemIndex) => itemIndex != imageIndex)
                                                      setFieldValue("images", images);
                                                   }}
                                                >  <i className='fas fa-times'></i>
                                                </span>
                                             </div>
                                             {values.colorLinking && (
                                                <div className="colorsList">
                                                   {values.colors.map((color, index) => {
                                                      return (
                                                         <div className={data.color == color && "active"} style={{ backgroundColor: color }}>
                                                            <i className='fas fa-check'
                                                               onClick={() => {
                                                                  let images = values.images;
                                                                  images[imageIndex].color = color;
                                                                  setFieldValue("images", images);
                                                               }}
                                                            ></i>
                                                         </div>
                                                      )
                                                   })}
                                                </div>
                                             )}
                                          </div>
                                       )
                                    }}
                                    onChange={(data) => {
                                       console.log(data);
                                       // setFieldValue("images", data?.map((data, index) => ({ ...data, id: index })));
                                       // setList(data)
                                       // if (updateInterval) {
                                       //  clearTimeout(updateInterval);
                                       // }
                                       // updateInterval = setTimeout(() => {
                                       toast.error("This feature is not yet available.");
                                       //  setFieldValue("multiPriceList", data);
                                       // }, 2000);
                                    }}
                                 />
                                 <div>
                                    <div className='pictureWrapper'>
                                       <div className='uploadNew'>
                                          <div className='uploadContent'>
                                             {filePercentageLoader < 100 ? (
                                                <div className='loadingSection'>
                                                   <span>Loading...</span>
                                                   <div className="progress" style={{ height: "4px", marginTop: "5px" }}>
                                                      <div className="progress-bar bg-success" role="progressbar" style={{ width: `${filePercentageLoader}%` }} aria-valuemax="100"></div>
                                                   </div>
                                                </div>
                                             ) : (
                                                <div className='uploadSection'>
                                                   <p className='mb-2'>Upload Picture</p>
                                                   <input
                                                      type="file"
                                                      id="uploadImages"
                                                      onChange={async (e) => {
                                                         if (e.target.value) {
                                                            if (e.currentTarget.files[0].type.split("/")[0] === "image") {
                                                               let file = e.currentTarget.files[0];
                                                               console.log(file)
                                                               let filePath = await gallery.uploadFile(file, "PRODUCT");
                                                               if (filePath) {
                                                                  const fileExists = values.images.some(image => image.url === filePath);
                                                                  if (!fileExists) {
                                                                     if (values?.images?.length == 0) {
                                                                        setFieldValue("image", filePath);
                                                                     }
                                                                     setFieldValue("images", [...values.images, {
                                                                        url: filePath,
                                                                        color: "",
                                                                     }])
                                                                  } else {
                                                                     toast.error("This file already exists.");
                                                                  }
                                                               }
                                                            } else {
                                                               toast.error("This file is not allowed to upload.");
                                                            }
                                                         } else {
                                                            toast.error("No file found to upload.");
                                                         }
                                                      }}
                                                      className="d-none"
                                                   />
                                                   <button
                                                      className='btn btn-primary'
                                                      onClick={() => {
                                                         document.getElementById("uploadImages").click();
                                                      }}
                                                      type="button">Upload</button>
                                                   <div className='mt-2'>
                                                      <small className='text-muted'>(Max size: 400KB)</small>
                                                      <div>
                                                         <button
                                                            className='btn btn-secondary mt-1'
                                                            onClick={() => {
                                                               setShowGallery(true)
                                                            }}
                                                            type="button">Pick from gallery</button>
                                                      </div>
                                                   </div>
                                                </div>
                                             )}
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                              <ErrorMessage name='image' component="small" className="text-danger" />
                           </div>
                           <div className="bg-white rounded-0 p-2 p-md-3 my-3 mt-4">
                              <h4>Stock/Pricing</h4>
                              <div className='mt-3'>
                                 <div className="form-check">
                                    <Field name="textCharge" className="form-check-input" type="checkbox" id="textOnProduct" />
                                    <label className="form-check-label" htmlFor="textOnProduct">
                                       Charge tax on this product
                                       <small className="text-muted ms-1">(Coming soon)</small>
                                    </label>
                                 </div>
                                 <div className="form-check">
                                    <Field name="sellEvenOutOfStock" className="form-check-input" type="checkbox" id="sellEvenOutOfStock" />
                                    <label className="form-check-label" htmlFor="sellEvenOutOfStock">
                                       Continue selling when out of stock
                                       <small className="text-muted ms-1">(Coming soon)</small>
                                    </label>
                                 </div>
                                 <div className="form-check">
                                    <Field name="multiPrices" className="form-check-input" type="checkbox" id="multiPrice" />
                                    <label className="form-check-label" htmlFor="multiPrice">
                                       Multiple prices for size, style, quantity or colors
                                    </label>
                                 </div>
                              </div>
                              <hr />
                              {/* ********************************** */}
                              {!values.multiPrices ? (
                                 <>
                                    <div className="d-flex justify-content-between gap-2 mt-2">
                                       <div className='flex-grow-1 mb-2'>
                                          <label htmlFor="">Selling Price</label>
                                          <div className="input-group   ">
                                             <span className="input-group-text rounded-0">{settings?.currencySymbol}</span>
                                             <Field name="sellPrice" type="number" className="form-control" placeholder="Amount" />
                                          </div>
                                          <ErrorMessage name='sellPrice' component="small" className="text-danger" />
                                       </div>
                                       <div className='flex-grow-1 mb-2'>
                                          <label htmlFor="">Regular Price</label>
                                          <div className="input-group">
                                             <span className="input-group-text rounded-0"  >{settings?.currencySymbol}</span>
                                             <Field name="oldPrice" type="number" className="form-control" placeholder="Amount" />
                                          </div>
                                          <ErrorMessage name='oldPrice' component="small" className="text-danger" />
                                       </div>
                                    </div>
                                    <div className="d-flex justify-content-between gap-2">
                                       <div className='w-50 mb-2'>
                                          <label htmlFor="">Cost per unit</label>
                                          <div className="input-group" >
                                             <span className="input-group-text rounded-0"  >{settings?.currencySymbol}</span>
                                             <Field name="cost" type="number" className="form-control" placeholder="Amount" />
                                          </div>
                                          <ErrorMessage name='cost' component="small" className="text-danger" />
                                       </div>
                                       <div className="d-flex justify-content-around  w-50">
                                          <div>
                                             <label htmlFor="">Profit/Loss</label>
                                             <div className={`${values.sellPrice - values.cost > 0 ? "text-success" : "text-danger"}`}> {settings?.currencySymbol} {values.sellPrice - values.cost}</div>
                                          </div>
                                          <div>
                                             <label htmlFor="">Profit Margin</label>
                                             <div className={`${values.sellPrice > 0 && values.cost > 0 ? ((values.sellPrice - values.cost) / values.sellPrice * 100).toFixed(2) > 0 ? "text-success" : "text-danger" : "text-muted"}`}>
                                                {values.sellPrice > 0 && values.cost > 0 ? ((values.sellPrice - values.cost) / values.sellPrice * 100).toFixed(2) : 0}%
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                    <div className="d-flex justify-content-between gap-2">
                                       <div className='flex-grow-1'>
                                          <label htmlFor="">Available Quantity</label>
                                          <Field name="stockInHand" disabled={values.sellEvenOutOfStock} type="number" className='form-control' />
                                          <ErrorMessage name='stockInHand' component="small" className="text-danger" />
                                       </div>
                                       <div className='flex-grow-1'>
                                          <label htmlFor="">Barcode (SKU/UPC)</label>
                                          <Field name="barCode" type="text" className='form-control' />
                                       </div>
                                    </div>
                                 </>
                              ) : (
                                 <>
                                    <div className='flex-grow-1'>
                                       <label htmlFor="">Chart Title</label>
                                       <Field name="optionsTitle" type="text"
                                          placeholder='Write title to view chart list.(Size chart || Color chart || Style chart)'
                                          className='form-control' />
                                       <ErrorMessage name='optionsTitle' component="small" className="text-danger" />

                                    </div>
                                    <br />
                                    <h5>{values.optionsTitle}</h5>
                                    <ErrorMessage name='multiPriceList' component="small" className="text-danger" />
                                    <MultiListing
                                       setShowMultiPriceForm={setShowMultiPriceForm}
                                       setMultiInputs={setMultiInputs}
                                       setFieldValue={setFieldValue}
                                       values={values}
                                       settings={settings} />

                                    <div className="d-flex justify-content-end">
                                       <div>
                                          <button className='bg-black pointer text-white text-center py-1 rounded'
                                             onClick={(e) => {
                                                e.preventDefault();
                                                setMultiInputs(initialValuesForMultiPriceForm);
                                                setShowMultiPriceForm(true);
                                             }}
                                          ><small>Add Price Option</small></button>
                                       </div>
                                    </div>

                                    {/* ***************************** */}
                                 </>
                              )}
                              {/* ********************************** */}
                           </div>
                           {/* ********************shipping related things*****************************  */}
                           <div className="bg-white rounded-0 p-2 p-md-3 my-3 mt-4">
                              <h4>Shipping</h4>
                              <div className="form-check mb-3">
                                 <Field name="physicalState" className="form-check-input" type="checkbox" id="shipping1" />
                                 <label className="form-check-label" htmlFor="shipping1">
                                    Physical product
                                 </label>
                              </div>
                              {values.physicalState ? (
                                 <>
                                    <p className="text-muted">Enter weight in KG and dimensions of the product in centimeters.</p>
                                    <div className="d-flex justify-content-between gap-2">
                                       <div className="w-50">
                                          <div className="input-group">
                                             <span className="input-group-text rounded-0">Weight</span>
                                             <Field name="weight" type="number" className="form-control" placeholder="0.5KG" />
                                          </div>
                                          <ErrorMessage name='weight' component="small" className="text-danger d-block" />
                                       </div>
                                       <div className="w-50">
                                          <div className="input-group">
                                             <span className="input-group-text rounded-0">Height</span>
                                             <Field name="height" type="number" className="form-control" placeholder="250cm" />
                                          </div>
                                          <ErrorMessage name='height' component="small" className="text-danger d-block" />
                                       </div>
                                    </div>
                                    <div className="d-flex justify-content-between gap-2 mt-3">
                                       <div className="w-50">
                                          <div className="input-group">
                                             <span className="input-group-text rounded-0 px-3">Width</span>
                                             <Field name="width" type="number" className="form-control" placeholder="250cm" />
                                          </div>
                                          <ErrorMessage name='width' component="small" className="text-danger d-block" />
                                       </div>
                                       <div className="w-50">
                                          <div className="input-group">
                                             <span className="input-group-text rounded-0">Length</span>
                                             <Field name="length" type="number" className="form-control" placeholder="250cm" />
                                          </div>
                                          <ErrorMessage name='length' component="small" className="text-danger d-block" />
                                       </div>
                                    </div>
                                    <hr />
                                    <p className="text-info">Your product weight will be {values?.weight > 0 ? values?.weight : 0}kg and dimension will be {values?.width > 0 ? values?.width : 0}cm x {values?.height > 0 ? values?.height : 0}cm x {values?.length > 0 ? values?.length : 0}cm.</p>
                                    <p className="text-danger">Make sure to enter correct weight and dimension. This information will be used to calculate shipping cost.</p>
                                 </>
                              ) : (
                                 <p className='text-muted'>This product will treated as digital product or service.</p>
                              )}
                           </div>
                           <div className="bg-white rounded-0 p-2 p-md-3 my-3 mt-4">
                              <h4>Custom input</h4>
                              <div className="form-check mb-3">
                                 <Field name="customInput" className="form-check-input" type="checkbox" id="customInput" />
                                 <label className="form-check-label" htmlFor="customInput">
                                    Custom input to take any information from your customers.
                                 </label>
                              </div>
                              {values.customInput ? (
                                 <div className="mb-3">
                                    <label>Enter your input title</label>
                                    <Field name="customInputTitle"
                                       placeholder='Enter your input title'
                                       type="text" className="form-control" />
                                    <ErrorMessage name='customInputTitle' component="small" className="text-danger" />
                                 </div>
                              ) : (
                                 <p className='text-muted'>Add custom input to get some information from customer like name or any other important information. </p>
                              )}
                           </div>
                           {values.title && (
                              <div className="bg-white rounded-0 p-3 my-3 mt-4">
                                 <div className='d-flex justify-content-between'>
                                    <div>
                                       <h4>Search Engine Optimization (SEO)</h4>
                                    </div>
                                    <div>
                                       <span className='text-info pointer'
                                          onClick={() => {
                                             setEditSeo(!editSeo);
                                             if (editSeo) {
                                                setFieldValue("metaDesc", values.description);
                                                setFieldValue("metaTitle", values.title);
                                             }
                                          }}
                                       >{!editSeo ? "Edit" : "Undo"}</span>
                                    </div>
                                 </div>
                                 <div className='mt-3'>
                                    <div className="seoContainer">
                                       <div className='pictureWrapper'>
                                          <img src={values.image} alt="" />
                                       </div>
                                       <div className='w-100'>
                                          <h4 className='mb-0 text-info'>{values.metaTitle}</h4>
                                          <p className='mb-0 text-success'><small>
                                             {values?.slug ? `https://${profile?.domain}/product/${values?.slug}` : "Product link will show after product save."}
                                          </small></p>
                                          <p className='mb-0 text-muted'><small>{values.metaDesc}</small></p>
                                       </div>
                                    </div>
                                 </div>
                                 {editSeo && (
                                    <>
                                       <hr />
                                       <div className="form-group">
                                          <label htmlFor="">Page title</label>
                                          <Field name="metaTitle" type="text" className='form-control' />
                                          <ErrorMessage name='metaTitle' component="small" className="text-danger" />
                                       </div>
                                       <div className="form-group">
                                          <label htmlFor="">Meta description</label>
                                          <textarea
                                             onChange={(event) => setFieldValue("metaDesc", event.target.value)}
                                             value={values.metaDesc}
                                             className='form-control'></textarea>
                                          <ErrorMessage name='metaDesc' component="small" className="text-danger" />
                                       </div>
                                    </>
                                 )}
                                 <br />
                              </div>
                           )}
                        </div>
                        <div className="col-md-4">
                           <button type="submit"
                              disabled={isSubmitting}
                              className='border-0 bg-black w-100 py-2 text-white bold'
                           >{isSubmitting ? "Loading..." : inputs._id ? "Update" : "Save"}</button>
                           <div className="mt-3">
                              {Object.entries(errors).map(([key, value]) => (
                                 <small key={key} className="text-danger d-block">{value}</small>
                              ))}
                           </div>

                           <div className="bg-white rounded-0 p-3 my-3 mt-2">
                              <div className="form-check">
                                 <Field name="sell" className="form-check-input" type="checkbox" id="formBasicCheckbox1" />
                                 <label className="form-check-label" htmlFor="formBasicCheckbox1">
                                    Start to sell
                                 </label>
                              </div>
                              <div className="form-check">
                                 <Field name="usedCondition" className="form-check-input" type="checkbox" id="usedCondition" />
                                 <label className="form-check-label" htmlFor="usedCondition">
                                    Used Condition
                                 </label>
                              </div>
                              <div className="form-check">
                                 <Field name="featured" className="form-check-input" type="checkbox" id="formBasicCheckbox4" />
                                 <label className="form-check-label" htmlFor="formBasicCheckbox4">
                                    Put on feature
                                 </label>
                              </div>
                              <div className="form-check">
                                 <Field name="newArrival" className="form-check-input" type="checkbox" id="formBasicCheckbox5" />
                                 <label className="form-check-label" htmlFor="formBasicCheckbox5">
                                    Put on new product(New)
                                 </label>
                              </div>
                              <div className="form-check">
                                 <Field name="sales" className="form-check-input" type="checkbox" id="formBasicCheckbox6" />
                                 <label className="form-check-label" htmlFor="formBasicCheckbox6">
                                    Put on sales
                                 </label>
                              </div>
                              <div className="form-check">
                                 <Field name="upcoming" className="form-check-input" type="checkbox" id="formBasicCheckbox7" />
                                 <label className="form-check-label" htmlFor="formBasicCheckbox7">
                                    Put on Upcoming
                                 </label>
                              </div>
                              {values.upcoming && (
                                 <div className="form-check">
                                    <Field name="takeUpcomingOrder" className="form-check-input" type="checkbox" id="formBasicCheckbox8" />
                                    <label className="form-check-label" htmlFor="formBasicCheckbox8">
                                       Take Upcoming Orders
                                    </label>
                                 </div>
                              )}

                           </div>
                           <div className="bg-white rounded-0 p-3 my-3 mt-4">
                              <div className="form-group">
                                 <label>Category</label>
                                 {categories?.loading ? (<div>Loading...</div>) : (
                                    <select className='form-control'
                                       value={values?.category}
                                       onChange={(event) => {
                                          let categoryId = event.target.value;
                                          setFieldValue("category", categoryId);
                                          let selectedIndex = categories?.data?.findIndex(data => data?._id == categoryId);
                                          setSubcategories(categories?.data[selectedIndex]?.subcategories);
                                          setFieldValue("subcategory", "");
                                       }}
                                    >
                                       <option value="">Select Category</option>
                                       {categories?.data?.map((data, index) => {
                                          return (
                                             <option value={data._id} key={index}>{data.name}</option>
                                          )
                                       })}
                                    </select>
                                 )}
                              </div>
                              <div className="form-group">
                                 <label>Subcategory</label>
                                 <select className='form-control'
                                    value={values?.subcategory}
                                    onChange={(event) => {
                                       let subcategoryId = event.target.value;
                                       setFieldValue("subcategory", subcategoryId);
                                    }}
                                 >
                                    <option value="">Select subcategory</option>
                                    {subcategories?.map((data, index) => {
                                       return (
                                          <option value={data._id} key={index}>{data.name}</option>
                                       )
                                    })}
                                 </select>
                              </div>
                              <div className="form-group">
                                 <label htmlFor="">Brand</label>
                                 {brands?.loading ? (<div>Loading...</div>) : (
                                    <select className='form-control'
                                       value={values?.brand}
                                       onChange={(event) => {
                                          setFieldValue("brand", event.target.value)
                                       }}
                                    >
                                       <option value="">Select Brand</option>
                                       {brands?.data?.map((data, index) => {
                                          return (
                                             <option value={data._id} key={index}>{data.name}</option>
                                          )
                                       })}
                                    </select>
                                 )}
                              </div>
                           </div>
                           <div className="bg-white rounded-0 p-3 my-3 mt-4">
                              <div className="colorsList">
                                 {values.colors.map((color, index) => {
                                    return (
                                       <div style={{ backgroundColor: color }}>
                                          <i className='fas fa-times'
                                             onClick={(e) => {
                                                e.preventDefault();
                                                Swal.fire({
                                                   title: "Are you sure?",
                                                   text: "You want to delete!",
                                                   icon: "info",
                                                   showCancelButton: true,
                                                   confirmButtonColor: "#3085d6",
                                                   cancelButtonColor: "#d33",
                                                   confirmButtonText: "Yes!"
                                                }).then((result) => {
                                                   if (result.isConfirmed) {
                                                      let colors = values.colors.filter(data => data != color)
                                                      setFieldValue("colors", colors);
                                                   }
                                                });

                                             }}
                                          ></i>
                                       </div>
                                    )
                                 })}
                              </div>
                              <div className="addNewColorWrapper pt-2 mt-2">
                                 <input name="title" type="color" className='border-0 rounded'
                                    onChange={(event) => {
                                       let selectedColor = event.target.value;
                                       if (selectedColor) {
                                          setColor(selectedColor);
                                       }
                                    }}
                                 />
                                 <button type="button" className="colorSaveBtn"
                                    onClick={() => {
                                       let colors = [...values.colors, color];
                                       if (color) {
                                          setFieldValue("colors", colors);
                                          setColor("");
                                       } else {
                                          toast.error("Please select any color.");
                                       }
                                    }}
                                 >save</button>
                              </div>
                              <br />
                              <div className="form-check">
                                 <Field name="colorLinking" className="form-check-input" type="checkbox" id="colorLinking" />
                                 <label className="form-check-label" htmlFor="colorLinking">
                                    Link color with images (colorLinking)
                                 </label>
                              </div>
                           </div>
                           <div className="bg-white rounded-0 p-3 my-3 mt-4">
                              <h4>Videos</h4>
                              <ul>
                                 {values.youtubeLinks.map((link, index) => {
                                    return (
                                       <li>
                                          <div className='d-flex justify-content-between'>
                                             <div style={{ width: "90%", overflow: "hidden" }}>
                                                <a href={link} target="_blank" rel="noopener noreferrer">
                                                   <small>{link}</small>
                                                </a>
                                             </div>
                                             <div>
                                                <i className="fas fa-trash pointer"
                                                   onClick={() => {
                                                      Swal.fire({
                                                         title: "Are you sure?",
                                                         text: "You won't be able to revert this!",
                                                         icon: "warning",
                                                         showCancelButton: true,
                                                         confirmButtonColor: "#3085d6",
                                                         cancelButtonColor: "#d33",
                                                         confirmButtonText: "Yes, delete it!"
                                                      }).then((result) => {
                                                         if (result.isConfirmed) {
                                                            Swal.fire({
                                                               title: "Deleted!",
                                                               text: "Removed successfully.",
                                                               icon: "success"
                                                            });
                                                            let links = values.youtubeLinks.filter(data => data != link)
                                                            setFieldValue("youtubeLinks", links);
                                                         }
                                                      });

                                                   }}
                                                ></i>
                                             </div>
                                          </div>
                                       </li>
                                    )
                                 })}
                              </ul>
                              <div className="input-group mb-3">
                                 <input name="title" type="text"
                                    className="form-control"
                                    value={youtubeLink}
                                    placeholder="https://youtube.com/vedio/url"
                                    onChange={(event) => {
                                       let youtubeInputLink = event.target.value;
                                       if (youtubeInputLink) {
                                          setYoutubeLink(youtubeInputLink);
                                       }
                                    }}
                                 />
                                 <span className="input-group-text rounded-0 pointer" id="basic-addon2"
                                    onClick={() => {
                                       if (youtubeLink) {
                                          if (!youtubeLink.includes("https://www.youtube.com")) {
                                             toast.error("Please enter valid youtube video link.")
                                             return
                                          }
                                          const videoId = youtubeLink.split("/").pop();
                                          console.log({ videoId })
                                          const id = videoId.includes("watch?v=") ? videoId.split("=").pop() : videoId;
                                          const videoIdLink = "https://www.youtube.com/embed/" + id
                                          console.log({ videoIdLink });
                                          let youtubeLinks = [...values.youtubeLinks, videoIdLink];
                                          setFieldValue("youtubeLinks", youtubeLinks);
                                          setYoutubeLink("");
                                       } else {
                                          toast.error("Please enter youtube link.");
                                       }
                                    }}
                                 >Add</span>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <Offcanvas show={showMultiPriceForm} placement="end" onHide={() => setShowMultiPriceForm(false)}>
                     <Offcanvas.Header closeButton>
                        <Offcanvas.Title>Add Price Option</Offcanvas.Title>
                     </Offcanvas.Header>
                     <Offcanvas.Body>
                        <MultiPriceForm
                           multiInputs={{
                              ...multiInputs, colors: values.colors.map(color => ({
                                 color: color,
                                 stockInHand: 1,
                              }))
                           }}
                           colorLinking={values.colorLinking}
                           multiPriceList={values?.multiPriceList || []}
                           setFieldValue={setFieldValue}
                           settings={settings}
                           setShowMultiPriceForm={setShowMultiPriceForm}
                           sellEvenOutOfStock={values.sellEvenOutOfStock}
                        />
                     </Offcanvas.Body>
                  </Offcanvas>
                  <Offcanvas className="container h-100 " show={showGallery} placement="bottom" onHide={() => setShowGallery(false)}>
                     <Offcanvas.Header closeButton>
                        <Offcanvas.Title>Select from gallery</Offcanvas.Title>
                     </Offcanvas.Header>
                     <Offcanvas.Body>
                        {showGallery && (
                           <GalleryList
                              picker={true}
                              selectFile={(file) => {
                                 const fileExists = values.images.some(image => image.url === file);
                                 if (!fileExists) {
                                    setFieldValue("images", [...values.images, {
                                       url: file,
                                       color: "",
                                    }])
                                    setShowGallery(false)
                                 } else {
                                    toast.error("This file already exists.");
                                 }
                              }}
                           />
                        )}
                     </Offcanvas.Body>
                  </Offcanvas>
               </Form>
            )}
         </Formik >

      </>
   )
}

export default AddProductForm